module.exports = __webpack_public_path__ + "static/media/flyer-2032-fr.7a947ca5.pdf";